import {AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {StockItem} from "../../../shared/view-model/store-management/stock-item.type";
import {StockItemService} from "../../services/stock-item-service/stock-item.service";
import {ActivatedRoute, Router} from "@angular/router";
import {StockItemFormComponent} from "../stock-item-form/stock-item-form.component";
import {Stock} from "../../../shared/view-model/stock";
import {appInjector} from "../../../index";
import {NewStockViewComponent} from "../../stock/new-stock-view/new-stock-view.component";
import {StockService} from "../../services/stock.service";
import {StockInput} from "../../services/stock-input.type";
import {StockItemInput} from "../../services/stock-item-input.type";
import * as _ from "lodash";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {ErrorHandlerService} from "../../../core/visbos-core/error-handling/error-handler.service";
import {Location} from "@angular/common";
import {forkJoin} from "rxjs/observable/forkJoin";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Component({
  selector: 'vb-edit-stock-item',
  templateUrl: './edit-stock-item.component.html',
  styleUrls: ['./edit-stock-item.component.css']
})
export class EditStockItemComponent implements OnInit, AfterViewChecked {

  @ViewChild(StockItemFormComponent)
  stockItemForm: StockItemFormComponent;

  item: StockItem;

  form: FormGroup;

  stockIdsToDelete: string[] = [];

  JSON;
  console;

  constructor(private fb: FormBuilder,
              private cd: ChangeDetectorRef,
              private siService: StockItemService,
              private stockService: StockService,
              private route: ActivatedRoute,
              private router: Router,
              private location: Location,
              private sessionActions: SessionActions,
              private err: ErrorHandlerService) {
    this.JSON = JSON;
    this.console = console;
  }

  stockItemCuid: BehaviorSubject<string>;

  ngOnInit() {
    this.item = this.route.snapshot.data['stockItem'];
    this.init();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
    //TODO: Very unperformant!!!
  }

  init() {
    this.form = this.fb.group({
      stock_item: StockItemFormComponent.initControl(this.fb),
      stocks: EditStockItemComponent.initStocks(this.fb)
    });
  }

  static initStocks(fb: FormBuilder = null, values?: Stock[]): FormArray {
    fb = fb ? fb : appInjector().get(FormBuilder);
    let ctrl = fb.array([]);

    if (values) {
      for (let stock of values) {
        ctrl.push(NewStockViewComponent.initControl(fb));
      }
    }

    return ctrl;
  }

  deleteStock(index: number) {
    let ctrl = <FormArray>this.form.get('stocks');
    let stockCuid = ctrl.controls[index].get('cuid').value;
    this.stockIdsToDelete.push(stockCuid);
    ctrl.removeAt(index);

  }

  addStock(values?: Stock) {
    let ctrl = <FormArray>this.form.get('stocks');
    let stockItemCuid = this.form.get('stock_item.cuid').value; // Retrieve actual CUID of stock item

    ctrl.push(NewStockViewComponent.initControl(this.fb));
  }

  save(item: { stock_item: StockItemInput, stocks: StockInput[] }) {

    item = this.completeFormData(item);

    let sti = this.siService.updateStockItem(item.stock_item);
    let st = this.stockService.updateStocks(item.stocks);

    //TODO: Does not work, when stock changes
    forkJoin(sti, st).subscribe(res => {
        this.sessionActions.pushMessage("Änderungen erfolgreich gespeichert!", MessageType.SUCCESS, "Artikelverwaltung");
        this.location.back();
      },
      err => {
        this.err.handleUserError(err, "Während der Änderung ist ein Fehler aufgetreten!");
      });

    for (let cuid of this.stockIdsToDelete) {
      this.stockService.deleteStock(cuid);
    }

  }

  completeFormData(item) {
    let data = Object.assign({}, item);

    if (_.has(data, 'stock_item.medicine')) {
      _.set(data, 'stock_item.medicine.administration_unit_id', _.get(item, 'stock_item.administration_unit_id'));
      _.set(data, 'stock_item.medicine.substances.0.administration_unit_id', _.get(item, 'stock_item.administration_unit_id'));
      _.set(data, 'stock_item.medicine.stock_item_id', _.get(item, 'stock_item.cuid'));
    }

    if (_.has(data, 'stock_item.products')) {
      data.stock_item.products.forEach(p => p.stock_item_id = _.get(item, 'stock_item.cuid'));
    }

    if (_.has(data, 'stocks')) {
      data.stocks.forEach(stock => stock.stock_item_id = _.get(item, 'stock_item.cuid'));
    }

    return data;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock-item/edit-stock-item/edit-stock-item.component.ts